import React, { FC, useEffect, useState } from "react";
import { getOrderDetail, request_cancel_order, request_exchange_order, request_return_order } from "../../Axios";
import ModalClose from "../Modal/ModalClose";
import { useLocation, useNavigate } from "react-router-dom";
import * as SOL from "../../styles/solda/StyledComponentSol";
import { cancelReasonSelectList, exchangeReasonSelectList, returnReasonSelectList } from "../../modules/Variable";
import IconArrow from "../../assets/icons/arrow_fold_40.svg";
import ModalYes from "../Modal/ModalYes";
import ModalLoading from "../Modal/ModalLoading";
import { extractColorOptionNodeNames } from "../../Utils";

interface IOrderData {
  alc_order_ID: number;
  alc_order_memo: string | null;
  alc_order_method: string;
  alc_order_method_kor: string;
  alc_order_modified: string | null;
  alc_order_number: string;
  alc_order_pay_date: string;
  alc_order_pay_status: number;
  alc_order_pay_status_name: string;
  alc_order_pay_total: number;
  alc_order_progress: number;
  alc_order_receiver_address_name: string;
  alc_order_receiver_big_area: string;
  alc_order_receiver_detail_address: string;
  alc_order_receiver_name: string;
  alc_order_receiver_phone_number: string;
  alc_order_receiver_road_address: string;
  alc_order_receiver_small_area: string;
  alc_order_receiver_zip_code: string;
  alc_order_refund_total: number;
  alc_order_registe: string;
  alc_order_requests: string;
  customer_ID_use_alc_order: number;
  imp_uid: string;
  alc_status: number;
};

interface CancelOrderProps {
  customerID: number;
  orderID: number;
  handleSelectOneOrderID: (alc_order_ID: number) => void;
}

const CancelOrder: FC<CancelOrderProps> = ({customerID, orderID, handleSelectOneOrderID}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [orderData, setOrderData] = useState<IOrderData>({
    alc_order_ID: 0,
    alc_order_memo: null,
    alc_order_method: '',
    alc_order_method_kor: '',
    alc_order_modified: null,
    alc_order_number: '',
    alc_order_pay_date: '',
    alc_order_pay_status: 0,
    alc_order_pay_status_name: '',
    alc_order_pay_total: 0,
    alc_order_progress: 0,
    alc_order_receiver_address_name: '',
    alc_order_receiver_big_area: '',
    alc_order_receiver_detail_address: '',
    alc_order_receiver_name: '',
    alc_order_receiver_phone_number: '',
    alc_order_receiver_road_address: '',
    alc_order_receiver_small_area: '',
    alc_order_receiver_zip_code: '',
    alc_order_refund_total: 0,
    alc_order_registe: '',
    alc_order_requests: '',
    customer_ID_use_alc_order: 0,
    imp_uid: '',
    alc_status: 0,
  });
  const [detailOrderList, setDetailOrderList] = useState<any[]>([]);
  const [totalPriceOrder, setTotalPriceOrder] = useState<number>(0);
  const [totalPriceOriginal, setTotalPriceOriginal] = useState<number>(0);

  const [toggleCancelReason, setToggleCancelReason] = useState<boolean>(false);
  const [cancelReasonStatus, setCancelReasonStatus] = useState<number>(0);
  const [cancelReasonLabel, setCancelReasonLabel] = useState<string>('');
  const [cancelOtherReason, setCancelOtherReason] = useState<string>('');

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalContent, setModalContent] = useState<string>('');
  const [isModalYesOpen, setIsModalYesOpen] = useState<boolean>(false);
  const [modalYesContent, setModalYesContent] = useState({
    text: '',
    confirmText: '',
    onConfirm: () => {}
  });

  useEffect(() => {
    if (cancelReasonStatus === 9) {
      setCancelOtherReason('');
    }
    let reason_list: any[] = [];
    switch (location.state.category) {
      case 'cancel' : reason_list = cancelReasonSelectList; break;
      case 'exchange' : reason_list = exchangeReasonSelectList; break;
      case 'return' : reason_list = returnReasonSelectList; break;
      default : reason_list = [];
    }
    let selected_reason = reason_list.find(tmp => tmp.value === cancelReasonStatus);
    if (selected_reason) {
      setCancelReasonLabel(selected_reason.label);
    }
  }, [cancelReasonStatus, location.state.category]);

  useEffect(() => {
    if (detailOrderList.length === 0) return;
    const price_total = detailOrderList.reduce((accumulator, current) => {
      return accumulator + (current.alc_detail_order_sell_price * current.alc_detail_order_quantity);
    }, 0);
    const price_total_origin = detailOrderList.reduce((accumulator, current) => {
      return accumulator + (current.alc_detail_order_sell_price_original * current.alc_detail_order_quantity);
    }, 0);
    setTotalPriceOrder(price_total);
    setTotalPriceOriginal(price_total_origin);
  }, [detailOrderList]);

  useEffect(() => {
    if (!orderID) {
      setModalContent('잘못된 접근입니다.');
      setIsModalOpen(true);
      navigate('/home');
    } else {
      getOrderDetail(
        orderID,
      ).then(result => {
        setOrderData(result.alc_order);
        setDetailOrderList(result.detail_rows);
      });
    };
  }, [customerID, navigate, orderID]);

  // 전체 취소
  const requestCancelOrder = () => {
    if (!cancelReasonStatus) {
      setModalContent('취소사유를 선택해 주세요.');
      setIsModalOpen(true);
    } else if (cancelReasonStatus === 9 && cancelOtherReason.trim() === "") {
      setModalContent('취소 상세사유를 작성해 주세요.');
      setIsModalOpen(true);
    } else {
      // TODO: 취소 가능한 주문여부는 FE에서 판단해서 버튼 숨기거나 하자
      setIsLoading(true);
      request_cancel_order(
        orderData,
        cancelReasonStatus,
        cancelOtherReason,
      ).then(result => {
        setIsLoading(false);
        let result_text = "";
        switch (result.category) {
          case 'pg_success' : result_text = "취소 및 환불처리가 완료되었습니다."; break;
          case 'pg_failed' : result_text = "주문취소 중 오류가 발생되었습니다. 070-4286-3556로 문의해주시기 바랍니다."; break;
          case 'beforeBankTransfer' : result_text = "주문 취소가 완료되었습니다."; break;
          case 'paidBankTransfer' : result_text = "취소/환불 신청이 완료되었습니다."; break;
          default : result_text = "";
        }
        if (result.code === 0) {
          setIsModalYesOpen(true);
          setModalYesContent({
            text: result_text,
            confirmText: '확인',
            onConfirm: () => {
              setIsModalYesOpen(false);
              handleSelectOneOrderID(orderData.alc_order_ID);
            }
          });
        } else {
          setIsModalYesOpen(true);
          setModalYesContent({
            text: result_text,
            confirmText: '확인',
            onConfirm: () => {
              setIsModalYesOpen(false);
              handleSelectOneOrderID(orderData.alc_order_ID);
            }
          });
        }
      });
    }
  };

  // 전체 교환 신청
  const requestExchangeOrder = () => {
    if (!cancelReasonStatus) {
      setModalContent('교환사유를 선택해 주세요.');
      setIsModalOpen(true);
    } else if (cancelReasonStatus === 9 && cancelOtherReason.trim() === "") {
      setModalContent('교환 상세사유를 작성해 주세요.');
      setIsModalOpen(true);
    } else {
      setIsLoading(true);
      request_exchange_order(
        orderData,
        cancelReasonStatus,
        cancelOtherReason,
      ).then(result => {
        if (result === 1) {
          setIsModalYesOpen(true);
          setModalYesContent({
            text: '교환 신청이 완료되었습니다.',
            confirmText: '확인',
            onConfirm: () => {
              setIsModalYesOpen(false);
              handleSelectOneOrderID(orderData.alc_order_ID);
            }
          });
        } else {
          setIsModalYesOpen(true);
          setModalYesContent({
            text: '교환신청 중 오류가 발생되었습니다. 070-4286-3556로 문의해주시기 바랍니다.',
            confirmText: '확인',
            onConfirm: () => {
              setIsModalYesOpen(false);
              handleSelectOneOrderID(orderData.alc_order_ID);
            }
          });
        }
      });
    }
  };

  // 전체 반품 신청
  const requestReturnOrder = () => {
    if (!cancelReasonStatus) {
      setModalContent('반품사유를 선택해 주세요.');
      setIsModalOpen(true);
    } else if (cancelReasonStatus === 9 && cancelOtherReason.trim() === "") {
      setModalContent('반품 상세사유를 작성해 주세요.');
      setIsModalOpen(true);
    } else {
      setIsLoading(true);
      request_return_order(
        orderData,
        cancelReasonStatus,
        cancelOtherReason,
      ).then(result => {
        if (result === 1) {
          setIsModalYesOpen(true);
          setModalYesContent({
            text: '반품 신청이 완료되었습니다.',
            confirmText: '확인',
            onConfirm: () => {
              setIsModalYesOpen(false);
              handleSelectOneOrderID(orderData.alc_order_ID);
            }
          });
        } else {
          setIsModalYesOpen(true);
          setModalYesContent({
            text: '반품신청 중 오류가 발생되었습니다. 070-4286-3556로 문의해주시기 바랍니다.',
            confirmText: '확인',
            onConfirm: () => {
              setIsModalYesOpen(false);
              handleSelectOneOrderID(orderData.alc_order_ID);
            }
          });
        }
      });
    }
  };

  return (
    <>
      <ModalLoading isOpen={isLoading} />
      <ModalClose
        isOpen={isModalOpen} 
        onClose={() => {
          setIsModalOpen(false);
        }} 
        text={modalContent}
      />
      <ModalYes
        isOpen={isModalYesOpen}
        onConfirm={modalYesContent.onConfirm}
        confirmText={modalYesContent.confirmText}
        text={modalYesContent.text}
      />
      <SOL.OrderSelectOneContainer>
        <div className="order-select-one-header">
          <h2 className='order-select-one-title w-[100%] pb-[10px] border-b-2 border-solid border-main_black'>
            {location.state.category === 'cancel' && "취소 신청"}
            {location.state.category === 'exchange' && "교환 신청"}
            {location.state.category === 'return' && "반품 신청"}
          </h2>
        </div>
        <SOL.OrderListItem style={{padding: "10px 30px"}}>
          {detailOrderList.map((tmp, idx) =>
            <div
              key={idx}
              className="order-detail-box"
              style={{border: (idx === 0 ? 0 : "")}}
            >
              <div className="order-detail-left">
                <div className='order-detail-image'>
                    <img src={tmp.color_b2c_image} alt={tmp.color_name} />
                </div>
                <div className='order-detail-product'>
                    <p className='brand'>{tmp.brand_kor_name}</p>
                    <p className='product'>{tmp.product_kor_name}</p>
                    <p className='color'>{tmp.color_name}</p>
                    <p className='quantity'>{tmp.alc_detail_order_quantity}개</p>
                    {tmp.alc_detail_order_option_array && (
                      <p className="offer-list-option">
                        {extractColorOptionNodeNames(JSON.parse(tmp.alc_detail_order_option_array))}
                      </p>
                    )}
                </div>
              </div>
              <div className="order-detail-right order-cancel">
                <div className='order-detail-price'>
                    <p className='detail-original-price'>{(tmp.alc_detail_order_sell_price_original * tmp.alc_detail_order_quantity).toLocaleString()}원</p>
                    <p className='detail-rated-price'>{(tmp.alc_detail_order_sell_price * tmp.alc_detail_order_quantity).toLocaleString()}원</p>
                </div>
              </div>
            </div>
          )}
        </SOL.OrderListItem>
        <SOL.CancelOrderInfo>
          <div className="cancel-order-title">
            {location.state.category === 'cancel' && "취소 사유"}
            {location.state.category === 'exchange' && "교환 사유"}
            {location.state.category === 'return' && "반품 사유"}
          </div>
          {location.state.category === 'cancel' && (
            <div className="cancel-reason-section">
              <div className="select-box">
                <div
                  className={`selected-reason ${cancelReasonStatus === 0 && "none-select"}`}
                  onClick={() => setToggleCancelReason(!toggleCancelReason)}
                >
                  <span>{cancelReasonLabel}</span>
                  <img src={IconArrow} alt="select-arrow" className={`${!toggleCancelReason && "rotate-180"}`} />
                </div>
                {toggleCancelReason && (
                  cancelReasonSelectList.filter(tmp => tmp.value !== 0).map((tmp, idx) =>
                    <SOL.BasicSelectListItem
                      key={tmp.value}
                      onClick={() => {
                        setCancelReasonStatus(tmp.value);
                        setToggleCancelReason(false);
                      }}
                    >
                      {tmp.label}
                    </SOL.BasicSelectListItem>
                  )
                )}
              </div>
            </div>
          )}
          {location.state.category === 'exchange' && (
            <div className="cancel-reason-section">
              <div className="select-box">
                <div
                  className={`selected-reason ${cancelReasonStatus === 0 && "none-select"}`}
                  onClick={() => setToggleCancelReason(!toggleCancelReason)}
                >
                  <span>{cancelReasonLabel}</span>
                  <img src={IconArrow} alt="select-arrow" className={`${!toggleCancelReason && "rotate-180"}`} />
                </div>
                {toggleCancelReason && (
                  exchangeReasonSelectList.filter(tmp => tmp.value !== 0).map((tmp, idx) =>
                    <SOL.BasicSelectListItem
                      key={tmp.value}
                      onClick={() => {
                        setCancelReasonStatus(tmp.value);
                        setToggleCancelReason(false);
                      }}
                    >
                      {tmp.label}
                    </SOL.BasicSelectListItem>
                  )
                )}
              </div>
            </div>
          )}
          {location.state.category === 'return' && (
            <div className="cancel-reason-section">
              <div className="select-box">
                <div
                  className={`selected-reason ${cancelReasonStatus === 0 && "none-select"}`}
                  onClick={() => setToggleCancelReason(!toggleCancelReason)}
                >
                  <span>{cancelReasonLabel}</span>
                  <img src={IconArrow} alt="select-arrow" className={`${!toggleCancelReason && "rotate-180"}`} />
                </div>
                {toggleCancelReason && (
                  returnReasonSelectList.filter(tmp => tmp.value !== 0).map((tmp, idx) =>
                    <SOL.BasicSelectListItem
                      key={tmp.value}
                      onClick={() => {
                        setCancelReasonStatus(tmp.value);
                        setToggleCancelReason(false);
                      }}
                    >
                      {tmp.label}
                    </SOL.BasicSelectListItem>
                  )
                )}
              </div>
            </div>
          )}
          {cancelReasonStatus === 9 && (
            <div className="other-reason-box">
              <textarea
                placeholder="50자 내의 상세 사유를 작성해 주세요."
                maxLength={50}
                value={cancelOtherReason}
                onChange={(e) => {
                  setCancelOtherReason(e.target.value);
                }}
              ></textarea>
            </div>
          )}
          <div className="horizontal-divide" />

          <div className="cancel-order-title">
            환불/결제 정보
          </div>
          <SOL.OrderPaymentInfoContainer style={{padding: "0 30px"}}>
            <div className='payment-info-box'>
              <div className='payment-info-flex'>
                  <span className="font-medium">주문 금액</span>
                  <span className="font-medium">{totalPriceOriginal.toLocaleString()}원</span>
              </div>
              <div className='payment-info-flex'>
                  <span className="font-medium">할인 금액</span>
                  <span className="font-medium">-{(totalPriceOriginal - totalPriceOrder).toLocaleString()}원</span>
              </div>
              <div className='payment-info-flex'>
                  <span className="font-medium">배송비</span>
                  {/* FIXME: 여기도 인테리어 채널 같은 곳은 물류팀과 회의해서 배송비 계산해줘야 함 */}
                  <span className="font-medium">0원</span>
              </div>
              <div className='payment-info-flex'>
                  <span className="font-medium">할인 금액</span>
                  <span className="font-medium">{totalPriceOrder.toLocaleString()}원</span>
              </div>
              <div className='horizontal' />
              <div className='payment-info-flex'>
                  <span className="font-medium">{orderData.alc_order_pay_status_name}</span>
              </div>
              <div className="payment-info-flex">
                <span>{orderData.alc_order_method_kor}</span>
                <span>{totalPriceOrder.toLocaleString()}원</span>
              </div>
            </div>
          </SOL.OrderPaymentInfoContainer>
          <div className="horizontal-divide" />
          <div className="refund-announce-box">
            <h3>* 환불 안내</h3>
            <p>- 무통장 입급</p>
            <p className="indentation">입금전 : 즉시 취소</p>
            <p className="indentation">입금 후 : 고객센터 확인 후 계좌 환불</p>
            <br />
            <p>- 신용카드/ 체크카드 결제</p>
            <p className="indentation">전체 취소 : 당일 취소 후 카드사에 따라 입금 진행</p>
            <p className="indentation">부분 취소 : 영업일 3~5일 취소 후 카드사에 따라 입금 진행</p>
          </div>  
          <div className="button-box">
            <SOL.BasicButton $width={230}>
              뒤로가기
            </SOL.BasicButton>
            <SOL.BasicButton
              $width={230}
              className="black"
              onClick={() => {
                if (location.state.category === 'cancel') {
                  requestCancelOrder();
                } else if (location.state.category === 'exchange') {
                  requestExchangeOrder();
                } else if (location.state.category === 'return') {
                  requestReturnOrder();
                }
              }}
            >
              {location.state.category === 'cancel' && '취소 신청'}
              {location.state.category === 'exchange' && '교환 신청'}
              {location.state.category === 'return' && '반품 신청'}
            </SOL.BasicButton>
          </div>
        </SOL.CancelOrderInfo>
      </SOL.OrderSelectOneContainer>
    </>
  )
};

export default CancelOrder;